/** ティア人数（calculateTiers と同一ロジック） */
export function tierBandCounts(n: number): { s: number; a: number; b: number; c: number } {
  return {
    s: Math.ceil(n * 0.1),
    a: Math.ceil(n * 0.1),
    b: Math.ceil(n * 0.2),
    c: Math.ceil(n * 0.3),
  };
}

/** 各ティアブロック先頭のインデックス（降順ソート済み配列で、下位ティアの最初） */
export function tierBoundaryCutIndices(n: number): number[] {
  const { s, a, b, c } = tierBandCounts(n);
  return [s, s + a, s + a + b, s + a + b + c];
}
